export default __webpack_public_path__ + "static/media/ecosistema_1920x1080.dacec134.gif";